import React, { Component } from "react";

class AssignGrandParentRow extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isFlipped: false
        };
        this.handleFlip = this.handleFlip.bind(this);
    }

    componentDidMount() {
        this.setState({
            isFlipped: this.props.gpData.gpAdded === 'Yes'
        });
    }

    handleFlip(userName) {
        try {
            this.setState(
                prevState => ({ isFlipped: !prevState.isFlipped }),
                () => this.props.handleToggleGP(userName)
            );
        } catch (error) {
            this.setState({ error: 'Oops! Something went wrong. Please try again later.' });
        }
    }

    render() {
        let { gpData, error } = this.props;
        return (
            <>
                <div>{gpData.userName}</div>
                <div>{gpData.fullName}</div>
                <div title={gpData.email}>{gpData.email}</div>
                <div>{gpData.gcComm}</div>
                <div>
                    <input
                        type="checkbox"
                        id={`flip-${gpData.userName}`}
                        checked={this.state.isFlipped}
                        onChange={() => this.handleFlip(gpData.userName)}
                        style={{ display: 'flex' }}
                    />
                    {/*<div className='toggle-switch'>
                        <label htmlFor={`flip-${gpData.userName}`}>Toggle</label>
                        {error && <span className="error">{error}</span>}
                    </div>*/}
                </div>
            </>
        );
    }
}

export default AssignGrandParentRow;
